var CONFUSEDCMS = CONFUSEDCMS || {},
    CSSCONSTANTS = CSSCONSTANTS || {};

(function ($) {

    CONFUSEDCMS.responsiveTabs = function () {
        var $tabSets = $('.' + CSSCONSTANTS.responsiveTabsClass);

        if (!$tabSets.hasClass(CSSCONSTANTS.responsiveTabsEnabledClass)) {	// if we haven't already called this function and enabled tabs
            $tabSets.addClass(CSSCONSTANTS.responsiveTabsEnabledClass);

			//loop through all sets of tabs on the page
			var tablistcount = 1;

			$tabSets.each(function() {

				var $tabs = $(this);

				// add tab heading and tab panel classes
				$tabs.children(':header').addClass(CSSCONSTANTS.responsiveTabsHeadingClass);
				$tabs.children('div').addClass(CSSCONSTANTS.responsiveTabsPanelClass);

				// determine if markup already identifies the active tab panel for this set of tabs
				// if not then set first heading and tab to be the active one
				var $activePanel = $tabs.find('.' + CSSCONSTANTS.responsiveTabsPanelActiveClass);
				if(!$activePanel.length) {
				    $activePanel = $tabs.find('.' + CSSCONSTANTS.responsiveTabsPanelClass).first().addClass(CSSCONSTANTS.responsiveTabsPanelActiveClass);
				}

				$tabs.find('.' + CSSCONSTANTS.responsiveTabsPanelClass).not('.' + CSSCONSTANTS.responsiveTabsPanelActiveClass).hide().attr('aria-hidden', 'true'); //hide all except active panel
				$activePanel.attr('aria-hidden', 'false');
				/* make active tab panel hidden for mobile */
				$activePanel.addClass(CSSCONSTANTS.responsiveTabsPanelClosedAccordionOnlyClass);

				// wrap tabs in container - to be dynamically resized to help prevent page jump
				var $tabsWrapper = $('<div/>', { 'class': CSSCONSTANTS.responsiveTabsWrapperClass });
				$tabs.wrap($tabsWrapper);

				var highestHeight = 0;

				// determine height of tallest tab panel. Used later to prevent page jump when tabs are clicked
				$tabs.find('.' + CSSCONSTANTS.responsiveTabsPanelClass).each(function () {
					var tabHeight = $(this).height();
					if (tabHeight > highestHeight) {
						highestHeight = tabHeight;
					}
				});

				var $tabList;

			    //create the tab list
				if ($tabs.hasClass(CSSCONSTANTS.responsiveTabsStepsClass)) {
				    $tabList = $('<ol/>', { 'class': CSSCONSTANTS.responsiveTabsListClass, 'role': 'tablist' });
				}
				else {
				    $tabList = $('<ul/>', { 'class': CSSCONSTANTS.responsiveTabsListClass, 'role': 'tablist' });
				}
				

				//loop through each heading in set
				var tabcount = 1;
				$tabs.find('.' + CSSCONSTANTS.responsiveTabsHeadingClass).each(function () {

				    var $tabHeading = $(this);
				    var $tabPanel = $(this).next();

				    $tabHeading.attr('tabindex', 0);

				    // CREATE TAB ITEMS (VISIBLE ON DESKTOP)
				    //create tab list item from heading
				    //associate tab list item with tab panel
				    var $tabListItem = $('<span/>', { 
				        id: 'tablist' + tablistcount + '-tab' + tabcount,
				        'aria-controls': 'tablist' + tablistcount +'-panel' + tabcount,
				        'role': 'tab',
				        tabindex: 0,
				        text: $tabHeading.text(),
				        keydown: function (objEvent) {
				            if (objEvent.keyCode === 13) { // if user presses 'enter'
				                $tabListItem.click();
				            }
				        },
				        click: function() {
				            //Show associated panel

				            //set height of tab container to highest panel height to avoid page jump
				            $tabsWrapper.css('height', highestHeight);

				            // remove hidden mobile class from any other panel as we'll want that panel to be open at mobile size
				            $tabs.find('.' + CSSCONSTANTS.responsiveTabsPanelClosedAccordionOnlyClass).removeClass(CSSCONSTANTS.responsiveTabsPanelClosedAccordionOnlyClass);
							
				            // close current panel and remove active state from its (hidden on desktop) heading
				            $tabs.find('.' + CSSCONSTANTS.responsiveTabsPanelActiveClass).toggle().removeClass(CSSCONSTANTS.responsiveTabsPanelActiveClass).attr('aria-hidden', 'true').prev().removeClass(CSSCONSTANTS.responsiveTabsHeadingActiveClass);
							
				            //make this tab panel active
				            $tabPanel.toggle().addClass(CSSCONSTANTS.responsiveTabsPanelActiveClass).attr('aria-hidden', 'false');

				            //make the hidden heading active
				            $tabHeading.addClass(CSSCONSTANTS.responsiveTabsHeadingActiveClass);

				            //remove active state from currently active tab list item
				            $tabList.find('.' + CSSCONSTANTS.responsiveTabsListItemActiveClass).removeClass(CSSCONSTANTS.responsiveTabsListItemActiveClass);

				            //make this tab active
				            $tabListItem.parent().addClass(CSSCONSTANTS.responsiveTabsListItemActiveClass);

				            //reset height of tab panels to auto
				            $tabsWrapper.css('height', 'auto');
				        }
				    });

				    //create list item to contain tab
				    var $tabListItemLi = $('<li/>', { 'class': CSSCONSTANTS.responsiveTabsListItemClass });
				    $tabListItem.prependTo($tabListItemLi);

				    //associate tab panel with tab list item
				    $tabPanel.attr({
				        'role': 'tabpanel',
				        'aria-labelledby': $tabListItem.attr('id'),
				        id: 'tablist' + tablistcount + '-panel' + tabcount
				    });

				    // if this is the active panel then make it the active tab item
				    if ($tabPanel.hasClass(CSSCONSTANTS.responsiveTabsPanelActiveClass)) {
				        $tabListItem.parent().addClass(CSSCONSTANTS.responsiveTabsListItemActiveClass);
				    }

					// add tab item
					$tabList.append($tabListItemLi);

					
					// TAB HEADINGS (VISIBLE ON MOBILE)
					// if user presses 'enter' on tab heading trigger the click event
					$tabHeading.keydown(function(objEvent) {
						if (objEvent.keyCode === 13) {
							$tabHeading.click();
						}
					});

					//toggle tab panel if click heading (on mobile)
					$tabHeading.click(function() {

						// remove any hidden mobile class
					    $tabs.find('.' + CSSCONSTANTS.responsiveTabsPanelClosedAccordionOnlyClass).removeClass(CSSCONSTANTS.responsiveTabsPanelClosedAccordionOnlyClass);

						// if this isn't currently active
						if (!$tabHeading.hasClass(CSSCONSTANTS.responsiveTabsHeadingActiveClass)) {

							var oldActivePos,
								$activeHeading = $tabs.find('.' + CSSCONSTANTS.responsiveTabsHeadingActiveClass);
								
							// if there is an active heading, get its position
							if($activeHeading.length) {
								oldActivePos = $activeHeading.offset().top;
							}
							
							// close currently active panel and remove active state from any hidden heading
							$tabs.find('.' + CSSCONSTANTS.responsiveTabsPanelActiveClass).slideToggle().removeClass(CSSCONSTANTS.responsiveTabsPanelActiveClass).prev().removeClass(CSSCONSTANTS.responsiveTabsHeadingActiveClass);
							
							//close all tabs
							$tabs.find('.' + CSSCONSTANTS.responsiveTabsPanelClass).hide().attr('aria-hidden', 'true');

							//open this panel
							$tabPanel.slideToggle().addClass(CSSCONSTANTS.responsiveTabsPanelActiveClass).attr('aria-hidden', 'false');

							// make this heading active
							$tabHeading.addClass(CSSCONSTANTS.responsiveTabsHeadingActiveClass);

							var $currentActive = $tabs.find('.' + CSSCONSTANTS.responsiveTabsListItemActiveClass);

							//set the active tab list item (for desktop)
							$currentActive.removeClass(CSSCONSTANTS.responsiveTabsListItemActiveClass);
							var panelId = $tabPanel.attr('id');
							var tabId = panelId.replace('panel','tab');
							$('#' + tabId).parent().addClass(CSSCONSTANTS.responsiveTabsListItemActiveClass);

							//scroll to active heading only if it is below previous one
							var tabsPos = $tabs.offset().top;
							var newActivePos = ($tabHeading.offset().top) - 15;
							if(oldActivePos < newActivePos) {
								$('html, body').animate({ scrollTop: tabsPos }, 0).animate({ scrollTop: newActivePos }, 400);
							}
							
						}

						// if this tab panel is already active
						else {

							// hide panel but give it special responsive-tabs__panel--closed-accordion-only class so that it can be visible at desktop size
						    $tabPanel.removeClass(CSSCONSTANTS.responsiveTabsPanelActiveClass).slideToggle(function () { $(this).addClass(CSSCONSTANTS.responsiveTabsPanelClosedAccordionOnlyClass); });

							//remove active heading class
							$tabHeading.removeClass(CSSCONSTANTS.responsiveTabsHeadingActiveClass);

							//don't alter classes on tabs as we want it active if put back to desktop size
						}
						
					});

					tabcount ++;

				});

				// add finished tab list to its container
				$tabs.prepend($tabList);

				// next set of tabs on page
				tablistcount ++;
			});
		}
	};
})(window.jQuery);
